import { forwardRef, ForwardedRef } from "react";
import {
  Grid2 as Grid,
  Box,
  Modal as MuiModal,
  Button,
  Stack,
} from "@mui/material";
import { useTranslate } from "@refinedev/core";
import { ModalRef } from "@shared/components";
import { useModalController } from "@shared/components/Modal/controller";
import { modalStyle } from "@shared/components/Modal/styles";

type ModalProps = {
  onConfirm: () => void;
  onClose: () => void;
};

export const ModalComplete = forwardRef(
  ({ onConfirm, onClose }: ModalProps, ref: ForwardedRef<ModalRef>) => {
    const translate = useTranslate();

    const { isOpen, handleClose } = useModalController(ref, {
      onClose,
    });

    return (
      <MuiModal open={isOpen} onClose={handleClose} keepMounted>
        <Box sx={modalStyle}>
          <Grid container spacing={3}>
            <Stack>
              <Box>
                <h2>App Criado com Sucesso!</h2>
                <p>
                  O aplicativo foi criado com sucesso. Aguarde a conclusão das
                  builds para Android e iOS, o que pode levar de 5 a 10 minutos.
                  Você pode acompanhar o progresso em{" "}
                  <a
                    href="https://expo.dev/accounts/partiu.vantagens"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "blue" }}
                  >
                    Expo Dev
                  </a>
                  . Após a conclusão, você poderá prosseguir para a segunda
                  etapa, que é submeter as builds geradas nas lojas.
                </p>
              </Box>
            </Stack>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="flex-end"
              width="100%"
            >
              <Button type="button" onClick={handleClose}>
                {translate("buttons.cancel")}
              </Button>

              <Button type="submit" variant="contained" onClick={onConfirm}>
                Continuar
              </Button>
            </Stack>
          </Grid>
        </Box>
      </MuiModal>
    );
  }
);
